// extracted by mini-css-extract-plugin
export default {"wrapper":"kB-z","viewport":"lB-z","container":"mB-z","slide":"nB-z"};